/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Detail_Col_Lot_CodeInputs */

const vi_pll_detail_col_lot_code = /** @type {(inputs: Pll_Detail_Col_Lot_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô`)
};

/**

* @param {Pll_Detail_Col_Lot_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_detail_col_lot_code = /** @type {((inputs?: Pll_Detail_Col_Lot_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Detail_Col_Lot_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_detail_col_lot_code(inputs)
});